export const getters = {
  getShoppingCart: state => {
    return state.list
  },
  getAddressInfo: state => {
    return state.addressInfo
  },
  getTakerInfo: state => {
    return state.takerInfo
  },
  getOrderCoupon: state => {
    return state.orderCoupon
  },
  getInvoiceTitle: state => {
    return state.invoiceTitle
  }
}



// WEBPACK FOOTER //
// ./src/stores/mall/getters.js